export const TOKEN = 'TRACKING';

export const TRACKING_API_PATHS = {
};
